import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AutoComplete from '../components/forms/AutoComplete';
import { Shapes } from '../models/entities';

import { loadClients } from '../actions/clients';

class ClientAutoComplete extends PureComponent {
  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
  }

  onSearch(query) {
    const { loadClients: refresh } = this.props;
    refresh(`name eq '${query}*'`);
  }

  render() {
    const {
      clients, onChange, disabled, defaultSelected, isLoading,
    } = this.props;
    return (
      <AutoComplete
        options={clients}
        onSearch={this.onSearch}
        onChange={onChange}
        placeholder={disabled ? '' : 'Search for a client...'}
        labelKey="name"
        disabled={disabled}
        defaultSelected={defaultSelected}
        isLoading={isLoading}
        id="clientAutoComplete"
      />
    );
  }
}

ClientAutoComplete.propTypes = {
  loadClients: PropTypes.func.isRequired,
  clients: PropTypes.arrayOf(Shapes.CLIENT),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  defaultSelected: PropTypes.oneOf([Shapes.USER, undefined]),
  isLoading: PropTypes.bool.isRequired,
};

ClientAutoComplete.defaultProps = {
  clients: null,
  disabled: false,
  defaultSelected: undefined,
};

const mapStateToProps = (state) => {
  const { pagination: { clients: pagination }, entities: { clients } } = state;
  return {
    isLoading: pagination.isFetching,
    clients: pagination.ids ? pagination.ids.map((id) => clients[id]) : [],
  };
};

export default connect(mapStateToProps, { loadClients })(ClientAutoComplete);
